<template>
  <vf-media-gallery
    v-if="product"
    :items="galleryItems"
    pagination
    :product-id="productId"
    @zoom="onZoom"
  >
    <template #default="{ i }">
      <base-button
        v-if="
          $feature.pdpShopTheLook
            && !!product.productSets?.length
            && (i === 0 || showShopTheLookButtonOnDesktop && i === 1)
        "
        class="absolute right-0 top-0 m-4 aspect-square f-col center rounded-full bg-white shadow-md"
        :class="{
          'lg:hidden': i === 0,
          '<lg:hidden': showShopTheLookButtonOnDesktop && i === 1,
        }"
        style="min-height: 4.625rem"
        @click="scrollToElement('shopTheLook')"
      >
        <span
          class="mx-2 mt-4 aspect-square w-min f-col center"
          :class="brandClasses.shopTheLookButton"
        >
          <span class="text-center text-xs">
            {{ $t.shopTheLookHeading }}
          </span>
          <vf-icon class="c-black" dir="down" name="chevron" size="sm" />
        </span>
      </base-button>
    </template>
  </vf-media-gallery>
</template>

<script setup lang="ts">
const { brandClasses, gallery: { showShopTheLookButtonOnDesktop } } = useAppConfig().pages?.pdp || {}
const { galleryItems, onZoom, product, productId } = usePdp()
</script>
